import { useParams } from 'react-router-dom';
import { useGetContent } from 'contexts/Content';

import { ArticleType } from 'types/article';
import { ContentCard } from 'components/Cards/ContentCard';
import {
  HeroShroud,
  ContentWrapper,
  CapsText,
  Header,
  SubHeader,
  Title,
  Tile,
  StyledContentImageCard,
} from './styles';
import { getPhaseString } from 'utils/pageHelpers';
import { SimpleNavBarExternal } from 'components/NavBar';
import { useLayoutEffect } from 'react';

function CareGuideDetails() {
  const { care_id } = useParams();
  const content = useGetContent(care_id as string);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (!content) return null;

  return (
    <>
      <SimpleNavBarExternal color="birch" to="https://commonsclinic.com/" />
      <HeroShroud />
      <ContentWrapper>
        <CapsText>{content.title}</CapsText>
        <Header>{getPhaseString(content.phase)}</Header>
        <SubHeader>{content.description}</SubHeader>
        <Title>Up Next</Title>
        <StyledContentImageCard
          image={content.articles[0].hero}
          imageAlt={
            content.articles[0].heroAlt ||
            `${content.articles[0].title} hero image`
          }
          label="Article"
          title={content.articles[0].title}
          description={content.articles[0].description}
          link={`/care/${care_id}/article/${content.articles[0].id}`}
          state={'not started'}
          isVideo={false}
        />
        <Title>All Content</Title>
        {!!content.articles &&
          content.articles.map((contentItem: ArticleType, index: number) => {
            if (index === 0) return null;
            return (
              <Tile key={contentItem.id}>
                <ContentCard
                  image={contentItem.hero || ''}
                  imageAlt={
                    contentItem.heroAlt || `${contentItem.title} hero image`
                  }
                  label={contentItem.type}
                  title={contentItem.title as string}
                  description={(contentItem.description as string) || ''}
                  link={`/care/${care_id}/${contentItem.type}/${contentItem.id}`}
                  state={'not started'}
                  isVideo={contentItem.type === 'video'}
                />
              </Tile>
            );
          })}
      </ContentWrapper>
    </>
  );
}

export default CareGuideDetails;
